// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button } from '@/components/ui/core';
import { PasswordInput } from '@/components/ui/inputs';
import { IconLock, IconArrowLeft, IconLockCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper, PasswordStrength } from '../components';

export default function ResetHeroImage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password:', password);
  };

  const passwordsMatch = password === confirmPassword;

  return (
    <AuthLayoutWrapper
      variant="cover"
      backgroundImage="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=80"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/reset-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                background: 'linear-gradient(135deg, #22c55e, #14b8a6)',
              }}
            >
              <IconLockCheck size={28} color="white" />
            </Center>
            <Title order={2} ta="center">New password</Title>
            <Text c="dimmed" size="sm" ta="center">
              Create a secure password
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <div>
              <PasswordInput
                label="New password"
                placeholder="Enter new password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && <PasswordStrength password={password} variant="bar" />}
            </div>

            <PasswordInput
              label="Confirm"
              placeholder="Confirm password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              error={confirmPassword && !passwordsMatch ? "Passwords don't match" : undefined}
            />

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: 'green', to: 'teal' }}
              disabled={!passwordsMatch || password.length < 8}
            >
              Reset password
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Button
            component={Link}
            to="/app/demo/auth-pages/login/cover"
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
          >
            Back to login
          </Button>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
